import { render, staticRenderFns } from "./ContMyDashboards.vue?vue&type=template&id=702b5586&scoped=true&lang=pug"
import script from "./ContMyDashboards.vue?vue&type=script&lang=js"
export * from "./ContMyDashboards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702b5586",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('702b5586')) {
      api.createRecord('702b5586', component.options)
    } else {
      api.reload('702b5586', component.options)
    }
    module.hot.accept("./ContMyDashboards.vue?vue&type=template&id=702b5586&scoped=true&lang=pug", function () {
      api.rerender('702b5586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/refactoring/ContMyDashboards.vue"
export default component.exports